import React, {useEffect, useState} from 'react';

import Wrapper from 'components/structure/Wrapper';
import Builder from 'components/Builder/Builder';
import Tabs from 'components/Builder/Tabs';
import Loader from 'components/Loader';

import useSession from 'hooks/useSession';

function Planner() {
	const [fetching, setFetching] = useState(true);

	const {
		getSession,
		loaded
	} = useSession();

	useEffect(() => {
		getSession();
	}, []);

	return (
		<Wrapper className="Planner" displayFooter={false}>
			{(fetching || loaded === false) && (
				<div className="loading-builder">
					<Loader />
				</div>
			)}
			{loaded && (<Tabs
				setFetchingGroup={setFetching}
			/>)}
			{loaded && (
				<Builder
					setFetchingGroup={setFetching}
				/>
			)}
		</Wrapper>
	);
}

export default Planner;
